module.exports = __webpack_public_path__ + "static/img/productBanner.eff9530.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productBanner.png
// module id = hq5d
// module chunks = 1